import topTitle from '@/components/title';
import { editMailing } from './../request';
import { mapState } from 'vuex';
import { logisticsSelectList } from './../utils';
export default {
  components: {
    topTitle
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  props: {
    mailingInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      logisticsSelectList,
      readOnly: true,
      dataFrom: {}
    };
  },
  methods: {
    onSubmit() {
      editMailing({
        claimsId: this.$route.params.id,
        logisticsCompany: this.dataFrom.csCompany,
        shipmentNum: this.dataFrom.expressNum
      }).then(res => {
        this.$message.success('操作成功!');
        this.mailingInfo = {
          csCompany: this.dataFrom.csCompany,
          expressNum: this.dataFrom.expressNum
        };
        this.readOnly = true;
      });
    },
    editFun() {
      if (!this.readOnly) {
        this.dataFrom = {
          csCompany: this.mailingInfo.csCompany,
          expressNum: this.mailingInfo.expressNum
        };
      }
    }
  }
};